(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    init();
  });

  const init = () => {
    document.addEventListener('variant:change', (e) => {
      updateVariantSubTitle(e.detail.variant);
    });
  };
  
  const selectors = {
    variantSubtitle: '[data-variant-subtitle] > span',
    variantColorOption: '[data-color-option]'
  };

  const updateVariantSubTitle = (variant) => {
    const colorOption = document.querySelector(selectors.variantColorOption).getAttribute('data-color-option');

    let variantColorTitle = variant.title
    if(colorOption && colorOption.length > 0){
      variantColorTitle = variant[colorOption]
    }
    const subTitleElements = document.querySelectorAll(selectors.variantSubtitle);
    subTitleElements.forEach((subtitle) => {
      subtitle.textContent = variantColorTitle;
    });
  };
})();
